var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"id":"logo-icon","src":_vm.organisationStore.icon,"lazy-src":_vm.organisationStore.icon,"height":"50%","contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }